// Permission categories and subcategories for PAM system
// These are used across Roles Page, Creating New Staff, and Staff Details
// Kept in sync with PERMISSION_MAPPING in trivelta_helper/role_constants.py.
// When the roles/permissions schema API is available the BE response takes
// precedence; these constants serve as a fallback.

/** All sidebar tabs and dropdown options for Sidebar Preview. Each id maps to role.permissions[id]. */
export const SIDEBAR_PREVIEW_ITEMS = [
  { id: "kpis", label: "KPIs", isSubItem: false },
  { id: "kpis.overview", label: "Overview", isSubItem: true },
  { id: "kpis.financials", label: "Financials", isSubItem: true },
  { id: "kpis.acquisition", label: "Acquisition", isSubItem: true },
  { id: "kpis.sportsbook", label: "Sportsbook", isSubItem: true },
  { id: "kpis.casino", label: "Casino", isSubItem: true },
  { id: "users", label: "Users", isSubItem: false },
  { id: "sportsbook", label: "Sportsbook", isSubItem: false },
  { id: "sportsbook.reporting.reporting_summary", label: "Reporting Summary", isSubItem: true },
  { id: "sportsbook.reporting.top_users", label: "Top Users", isSubItem: true },
  { id: "sportsbook.fieldbook.events_list", label: "Events List", isSubItem: true },
  { id: "sportsbook.monitoring.latest_bets_list", label: "Latest Bets List", isSubItem: true },
  { id: "sportsbook.monitoring.sgp_risk", label: "SGP Risk", isSubItem: true },
  { id: "sportsbook.configuration.bet_limits", label: "Bet Settings", isSubItem: true },
  { id: "sportsbook.configuration.sgp_limits", label: "SGP Limits", isSubItem: true },
  { id: "sportsbook.configuration.account_config", label: "Account Config", isSubItem: true },
  { id: "sportsbook.configuration.sportsbook_fm", label: "Sportsbook FM", isSubItem: true },
  { id: "sportsbook.configuration.early_payout", label: "Early Payout", isSubItem: true },
  { id: "casino", label: "Casino", isSubItem: false },
  { id: "casino.reports.finance", label: "Finance", isSubItem: true },
  { id: "casino.reports.providers", label: "Providers", isSubItem: true },
  { id: "casino.reports.games", label: "Games", isSubItem: true },
  { id: "casino.reports.top_users", label: "Top Users", isSubItem: true },
  { id: "casino.configuration.casino_fm", label: "Casino FM", isSubItem: true },
  { id: "casino.configuration.games", label: "Casino FM Games", isSubItem: true },
  { id: "casino.configuration.providers", label: "Casino FM Providers", isSubItem: true },
  { id: "casino.configuration.collections", label: "Casino FM Collections", isSubItem: true },
  { id: "casino.configuration.views", label: "Casino FM Views", isSubItem: true },
  { id: "casino.configuration.tags", label: "Casino FM Tags", isSubItem: true },
  { id: "casino.configuration.preview", label: "Casino FM Preview", isSubItem: true },
  { id: "casino.configuration.features", label: "Casino FM Features", isSubItem: true },
  { id: "casino.configuration.uploads", label: "Casino FM Uploads", isSubItem: true },
  { id: "predictions", label: "Predictions", isSubItem: false },
  { id: "predictions.reports", label: "Reports", isSubItem: true },
  { id: "predictions.configuration", label: "Configuration", isSubItem: true },
  { id: "poker", label: "Poker", isSubItem: false },
  { id: "poker.reporting.top_users", label: "Top Users", isSubItem: true },
  { id: "poker.configuration.cash_game_limits", label: "Cash Game Limits", isSubItem: true },
  { id: "poker.configuration.stakes", label: "Stakes", isSubItem: true },
  { id: "poker.configuration.private_games", label: "Private Games", isSubItem: true },
  { id: "poker.configuration.tournaments", label: "Tournaments", isSubItem: true },
  { id: "poker.configuration.timebank", label: "Timebank", isSubItem: true },
  { id: "poker.configuration.features", label: "Features", isSubItem: true },
  { id: "promotions", label: "Promotions", isSubItem: false },
  { id: "promotions.bonus_controls", label: "Bonus Controls", isSubItem: true },
  { id: "promotions.affiliates", label: "Affiliate Module", isSubItem: true },
  { id: "promotions.utm_reports", label: "UTM Reports", isSubItem: true },
  { id: "promotions.campaigns", label: "Campaigns", isSubItem: true },
  { id: "promotions.templates", label: "Templates", isSubItem: true },
  { id: "promotions.segments", label: "Segments", isSubItem: true },
  { id: "payments", label: "Payments", isSubItem: false },
  { id: "payments.reports.overview", label: "Overview", isSubItem: true },
  { id: "payments.reports.report_generator", label: "Report Generator", isSubItem: true },
  { id: "payments.configuration.routing", label: "Routing", isSubItem: true },
  { id: "payments.configuration.delayed_payment", label: "Delayed Payment", isSubItem: true },
  { id: "payments.configuration.limits", label: "Limits", isSubItem: true },
  { id: "compliance", label: "Compliance", isSubItem: false },
  { id: "compliance.wallet", label: "Wallet", isSubItem: true },
  { id: "compliance.withdrawal_review", label: "Withdrawal Review", isSubItem: true },
  { id: "compliance.withdrawal_review.overview", label: "Withdrawal Review — Overview", isSubItem: true },
  { id: "compliance.withdrawal_review.rules", label: "Withdrawal Review — Rules", isSubItem: true },
  { id: "compliance.fraud_detection", label: "Fraud Detection", isSubItem: true },
  { id: "compliance.duplicate_identity_review.overview", label: "Duplicate Identity Review — Overview", isSubItem: true },
  { id: "compliance.duplicate_identity_review.resolve", label: "Duplicate Identity Review — Resolve", isSubItem: true },
  { id: "compliance.duplicate_identity_review.trigger_merge", label: "Duplicate Identity Review — Trigger Merge", isSubItem: true },
  { id: "compliance.maintenance_mode.view", label: "Maintenance Mode — View", isSubItem: true },
  { id: "compliance.maintenance_mode.update", label: "Maintenance Mode — Update", isSubItem: true },
  { id: "compliance.configuration.bet_limits", label: "Bet Limits", isSubItem: true },
  { id: "compliance.configuration.kyc_checkpoints", label: "KYC Checkpoints", isSubItem: true },
  { id: "configurations", label: "Configurations", isSubItem: false },
  { id: "configurations.profile", label: "Profile", isSubItem: true },
  { id: "configurations.state_configuration", label: "State Configuration", isSubItem: true },
  // Lives under the Configurations tab but keeps its casino permission key
  // (purposes are casino-only today) — see CONFIGURATIONS_OPTIONS.
  { id: "casino.scheduled_tasks.read", label: "Scheduled Tasks", isSubItem: true },
  { id: "staff_management", label: "Staff Management", isSubItem: false },
  { id: "staff_management.roles", label: "Roles", isSubItem: true },
  { id: "staff_management.staff", label: "Staff", isSubItem: true },
  { id: "staff_management.agent_audit_log", label: "Agent Audit Log", isSubItem: true },
  { id: "staff_management.agent_audit_log.wallet", label: "Agent Audit Log — Wallet", isSubItem: true },
  { id: "staff_management.agent_audit_log.suspensions", label: "Agent Audit Log — Suspensions", isSubItem: true },
  { id: "staff_management.agent_audit_log.promos", label: "Agent Audit Log — Promotions", isSubItem: true },
  { id: "staff_management.agent_audit_log.sports_bets", label: "Agent Audit Log — Sports Bets", isSubItem: true },
  { id: "staff_management.agent_audit_log.withdrawals", label: "Agent Audit Log — Withdrawals", isSubItem: true },
];

export function getPermissionGroupsForForm() {
  const groups = [];
  let currentGroup = null;
  SIDEBAR_PREVIEW_ITEMS.forEach((item) => {
    if (!item.isSubItem) {
      currentGroup = { id: item.id, label: item.label, children: [] };
      groups.push(currentGroup);
    } else if (currentGroup) {
      currentGroup.children.push({ id: item.id, label: item.label });
    }
  });
  return groups;
}

export const PERMISSION_CATEGORIES = [
  {
    id: "kpis",
    label: "KPIs",
    subcategories: [
      { id: "kpis.overview", label: "Overview" },
      { id: "kpis.financials", label: "Financials" },
      { id: "kpis.acquisition", label: "Acquisition" },
      { id: "kpis.sportsbook", label: "Sportsbook" },
      { id: "kpis.casino", label: "Casino" },
    ],
  },
  {
    id: "users",
    label: "Users",
    subcategories: [],
  },
  {
    id: "sportsbook",
    label: "Sportsbook",
    subcategories: [
      { id: "sportsbook.reporting.reporting_summary", label: "Reporting Summary" },
      { id: "sportsbook.reporting.top_users", label: "Top Users" },
      { id: "sportsbook.fieldbook.events_list", label: "Events List" },
      { id: "sportsbook.monitoring.latest_bets_list", label: "Latest Bets List" },
      { id: "sportsbook.monitoring.sgp_risk", label: "SGP Risk" },
      { id: "sportsbook.configuration.bet_limits", label: "Bet Settings" },
      { id: "sportsbook.configuration.sgp_limits", label: "SGP Limits" },
      { id: "sportsbook.configuration.account_config", label: "Account Config" },
      { id: "sportsbook.configuration.sportsbook_fm", label: "Sportsbook FM" },
      { id: "sportsbook.configuration.early_payout", label: "Early Payout" },
    ],
  },
  {
    id: "casino",
    label: "Casino",
    subcategories: [
      { id: "casino.reports.finance", label: "Finance" },
      { id: "casino.reports.providers", label: "Providers" },
      { id: "casino.reports.games", label: "Games" },
      { id: "casino.reports.top_users", label: "Top Users" },
      { id: "casino.configuration.casino_fm", label: "Casino FM" },
      { id: "casino.configuration.games", label: "Casino FM Games" },
      { id: "casino.configuration.providers", label: "Casino FM Providers" },
      { id: "casino.configuration.collections", label: "Casino FM Collections" },
      { id: "casino.configuration.views", label: "Casino FM Views" },
      { id: "casino.configuration.tags", label: "Casino FM Tags" },
      { id: "casino.configuration.preview", label: "Casino FM Preview" },
      { id: "casino.configuration.features", label: "Casino FM Features" },
      { id: "casino.configuration.uploads", label: "Casino FM Uploads" },
      { id: "casino.scheduled_tasks.read", label: "Scheduled Tasks" },
      { id: "casino.scheduled_tasks.trigger", label: "Scheduled Tasks Trigger" },
    ],
  },
  {
    id: "predictions",
    label: "Predictions",
    subcategories: [
      { id: "predictions.reports", label: "Reports" },
      { id: "predictions.configuration", label: "Configuration" },
    ],
  },
  {
    id: "poker",
    label: "Poker",
    subcategories: [
      { id: "poker.reporting.top_users", label: "Top Users" },
      { id: "poker.configuration.cash_game_limits", label: "Cash Game Limits" },
      { id: "poker.configuration.stakes", label: "Stakes" },
      { id: "poker.configuration.private_games", label: "Private Games" },
      { id: "poker.configuration.tournaments", label: "Tournaments" },
      { id: "poker.configuration.timebank", label: "Timebank" },
      { id: "poker.configuration.features", label: "Features" },
    ],
  },
  {
    id: "promotions",
    label: "Promotions",
    subcategories: [
      { id: "promotions.bonus_controls", label: "Bonus Controls" },
      { id: "promotions.affiliates", label: "Affiliate Module" },
      { id: "promotions.utm_reports", label: "UTM Reports" },
      { id: "promotions.campaigns", label: "Campaigns" },
      { id: "promotions.templates", label: "Templates" },
      { id: "promotions.segments", label: "Segments" },
    ],
  },
  {
    id: "payments",
    label: "Payments",
    subcategories: [
      { id: "payments.reports.overview", label: "Overview" },
      { id: "payments.reports.report_generator", label: "Report Generator" },
      { id: "payments.configuration.routing", label: "Routing" },
      { id: "payments.configuration.delayed_payment", label: "Delayed Payment" },
      { id: "payments.configuration.limits", label: "Limits" },
    ],
  },
  {
    id: "compliance",
    label: "Compliance",
    subcategories: [
      { id: "compliance.wallet", label: "Wallet" },
      { id: "compliance.withdrawal_review", label: "Withdrawal Review" },
      { id: "compliance.withdrawal_review.overview", label: "Withdrawal Review — Overview" },
      { id: "compliance.withdrawal_review.rules", label: "Withdrawal Review — Rules" },
      { id: "compliance.fraud_detection", label: "Fraud Detection" },
      { id: "compliance.duplicate_identity_review.overview", label: "Duplicate Identity Review — Overview" },
      { id: "compliance.duplicate_identity_review.resolve", label: "Duplicate Identity Review — Resolve" },
      { id: "compliance.duplicate_identity_review.trigger_merge", label: "Duplicate Identity Review — Trigger Merge" },
      { id: "compliance.maintenance_mode.view", label: "Maintenance Mode — View" },
      { id: "compliance.maintenance_mode.update", label: "Maintenance Mode — Update" },
      { id: "compliance.configuration.bet_limits", label: "Bet Limits" },
      { id: "compliance.configuration.kyc_checkpoints", label: "KYC Checkpoints" },
    ],
  },
  {
    id: "configurations",
    label: "Configurations",
    subcategories: [
      { id: "configurations.profile", label: "Profile" },
      { id: "configurations.state_configuration", label: "State Configuration" },
    ],
  },
  {
    id: "staff_management",
    label: "Staff Management",
    subcategories: [
      { id: "staff_management.roles", label: "Roles" },
      { id: "staff_management.staff", label: "Staff" },
      { id: "staff_management.agent_audit_log", label: "Agent Audit Log" },
      { id: "staff_management.agent_audit_log.wallet", label: "Agent Audit Log — Wallet" },
      { id: "staff_management.agent_audit_log.suspensions", label: "Agent Audit Log — Suspensions" },
      { id: "staff_management.agent_audit_log.promos", label: "Agent Audit Log — Promotions" },
      { id: "staff_management.agent_audit_log.sports_bets", label: "Agent Audit Log — Sports Bets" },
      { id: "staff_management.agent_audit_log.withdrawals", label: "Agent Audit Log — Withdrawals" },
    ],
  },
];

/** Keys for Duplicate Identity Review (overview / resolve / trigger merge). */
export const DUPLICATE_IDENTITY_REVIEW_PERMISSIONS = {
  OVERVIEW: "compliance.duplicate_identity_review.overview",
  RESOLVE: "compliance.duplicate_identity_review.resolve",
  TRIGGER_MERGE: "compliance.duplicate_identity_review.trigger_merge",
};

/** Route / Sider OR list: any duplicate-identity permission opens the page. */
export const DUPLICATE_IDENTITY_REVIEW_ROUTE_PERMISSIONS = [
  DUPLICATE_IDENTITY_REVIEW_PERMISSIONS.OVERVIEW,
  DUPLICATE_IDENTITY_REVIEW_PERMISSIONS.RESOLVE,
  DUPLICATE_IDENTITY_REVIEW_PERMISSIONS.TRIGGER_MERGE,
];

/** Parent + tab-level keys for Withdrawal Review (V2 Overview / Rules). */
export const WITHDRAWAL_REVIEW_PERMISSIONS = {
  PARENT: "compliance.withdrawal_review",
  OVERVIEW: "compliance.withdrawal_review.overview",
  RULES: "compliance.withdrawal_review.rules",
};

/** Parent + tab-level keys for Agent Audit Log (All / Wallet / WR / …). */
export const AGENT_AUDIT_LOG_PERMISSIONS = {
  ALL: "staff_management.agent_audit_log",
  WALLET: "staff_management.agent_audit_log.wallet",
  SUSPENSIONS: "staff_management.agent_audit_log.suspensions",
  PROMOS: "staff_management.agent_audit_log.promos",
  SPORTS_BETS: "staff_management.agent_audit_log.sports_bets",
  WITHDRAWALS: "staff_management.agent_audit_log.withdrawals",
};

/** View / update keys for Compliance → Maintenance Mode. */
export const MAINTENANCE_MODE_PERMISSIONS = {
  VIEW: "compliance.maintenance_mode.view",
  UPDATE: "compliance.maintenance_mode.update",
};

/**
 * Route / Sider OR list: view or update can open the page.
 * Toggles still require `UPDATE` in-page.
 */
export const MAINTENANCE_MODE_ROUTE_PERMISSIONS = [
  MAINTENANCE_MODE_PERMISSIONS.VIEW,
  MAINTENANCE_MODE_PERMISSIONS.UPDATE,
];

/**
 * Route / Sider OR list: parent or either tab key.
 * Opening the page still requires a matching tab key to render Overview
 * or Rules — parent alone does not show those tabs.
 */
export const WITHDRAWAL_REVIEW_ROUTE_PERMISSIONS = [
  WITHDRAWAL_REVIEW_PERMISSIONS.PARENT,
  WITHDRAWAL_REVIEW_PERMISSIONS.OVERVIEW,
  WITHDRAWAL_REVIEW_PERMISSIONS.RULES,
];

/**
 * Route / Sider OR list: All (parent) or any tab key.
 * Opening the page still requires a matching tab key to render content —
 * All alone shows only the All tab.
 */
export const AGENT_AUDIT_LOG_ROUTE_PERMISSIONS = [
  AGENT_AUDIT_LOG_PERMISSIONS.ALL,
  AGENT_AUDIT_LOG_PERMISSIONS.WALLET,
  AGENT_AUDIT_LOG_PERMISSIONS.SUSPENSIONS,
  AGENT_AUDIT_LOG_PERMISSIONS.PROMOS,
  AGENT_AUDIT_LOG_PERMISSIONS.SPORTS_BETS,
  AGENT_AUDIT_LOG_PERMISSIONS.WITHDRAWALS,
];

/** Each Overview / Rules tab requires its own granular permission key. */
export function canAccessWithdrawalReviewTab(adminPermissions, tab) {
  if (!Array.isArray(adminPermissions)) return false;
  if (tab === "overview") {
    return adminPermissions.includes(WITHDRAWAL_REVIEW_PERMISSIONS.OVERVIEW);
  }
  if (tab === "rules") {
    return adminPermissions.includes(WITHDRAWAL_REVIEW_PERMISSIONS.RULES);
  }
  return false;
}

/** ManualActions tab value → required permission key. */
const AGENT_AUDIT_LOG_TAB_PERMISSIONS = {
  all: AGENT_AUDIT_LOG_PERMISSIONS.ALL,
  wallet: AGENT_AUDIT_LOG_PERMISSIONS.WALLET,
  withdrawals: AGENT_AUDIT_LOG_PERMISSIONS.WITHDRAWALS,
  promos: AGENT_AUDIT_LOG_PERMISSIONS.PROMOS,
  "sports-bets": AGENT_AUDIT_LOG_PERMISSIONS.SPORTS_BETS,
  suspensions: AGENT_AUDIT_LOG_PERMISSIONS.SUSPENSIONS,
};

/** Each Agent Audit Log tab requires its own granular permission key. */
export function canAccessAgentAuditLogTab(adminPermissions, tab) {
  if (!Array.isArray(adminPermissions)) return false;
  const required = AGENT_AUDIT_LOG_TAB_PERMISSIONS[tab];
  if (!required) return false;
  return adminPermissions.includes(required);
}

// ===========================================================================
// Role actions — one-level grouping
// ===========================================================================
// `available_actions` is a flat list (~37 keys and growing), which is far too
// crowded to scan. These helpers bucket it into the *top-level* sidebar
// categories above, so the Actions column reads with the same taxonomy as the
// Sidebar Preview beside it. Actions are grouped by the product surface they
// act on: a config/FM action lives with its product (Edit Sportsbook
// Configuration → Sportsbook), not under a separate "Configurations" bucket.
// `general` leads the list — it holds the role-wide Read Only Access lock.
//
// Kept in sync with ACTIONS_MAPPING in trivelta_helper/role_constants.py.
// Unmapped keys fall into `general` rather than disappearing, so a new backend
// action is always reachable in the UI before this map is updated.

/** Catch-all for cross-cutting actions and any key not mapped below. */
export const ACTION_CATEGORY_GENERAL = "general";

/**
 * Flat (non-dotted) action key → top-level sidebar category id.
 * Dotted keys resolve from their prefix instead — see `resolveActionCategoryId`.
 */
export const ACTION_CATEGORY_BY_KEY = {
  // Users
  edit_user_wallet: "users",
  edit_app_user: "users",
  add_limits: "users",
  suspend_user: "users",
  unsuspend_user: "users",
  delete_user: "users",
  create_user_note: "users",
  edit_user_note: "users",
  delete_user_note: "users",
  pin_user_note: "users",
  unpin_user_note: "users",
  view_user_seon_cooldown: "users",
  clear_user_seon_cooldown: "users",
  // Sportsbook
  settle_bet: "sportsbook",
  edit_sportsbook_fm: "sportsbook",
  edit_sportsbook_configuration: "sportsbook",
  // Casino
  edit_casino_fm: "casino",
  // Promotions
  add_promo: "promotions",
  manage_affiliates: "promotions",
  edit_referrals: "promotions",
  // Payments
  edit_transaction_routing: "payments",
  // Compliance
  review_withdrawal: "compliance",
  refund_withdrawal: "compliance",
  manage_payment_rules: "compliance",
  edit_kyc_checkpoints: "compliance",
  // Staff Management
  create_pam_user: "staff_management",
  edit_pam_user: "staff_management",
  create_edit_pam_role: "staff_management",
  suspend_disable_pam_user: "staff_management",
  // General — platform-wide, no sidebar tab of its own
  mcp_access: ACTION_CATEGORY_GENERAL,
  // Not a member of `available_actions`: a role-level field rendered as a row.
  read_only_access: ACTION_CATEGORY_GENERAL,
};

/**
 * Dotted action prefixes whose first segment is not itself a sidebar category
 * (`fraud.rules.get`, `bets.list`). Prefixes that already match a category id
 * (`users.export`, `payments.reports.export`) need no entry.
 */
const ACTION_CATEGORY_PREFIX_ALIASES = {
  fraud: "compliance",
  bets: "sportsbook",
};

/**
 * Top-level sidebar ids in sidebar order, with the catch-all group pinned
 * first: General carries the role-wide Read Only Access lock, which outranks
 * any single product's actions.
 */
const TOP_LEVEL_SIDEBAR_IDS = SIDEBAR_PREVIEW_ITEMS.filter(
  (item) => !item.isSubItem,
).map((item) => item.id);

export const ACTION_CATEGORY_ORDER = [
  ACTION_CATEGORY_GENERAL,
  ...TOP_LEVEL_SIDEBAR_IDS,
];

const TOP_LEVEL_SIDEBAR_LABELS = SIDEBAR_PREVIEW_ITEMS.filter(
  (item) => !item.isSubItem,
).reduce((acc, item) => ({ ...acc, [item.id]: item.label }), {});

/** @param {string} actionKey */
export function resolveActionCategoryId(actionKey) {
  if (typeof actionKey !== "string" || !actionKey) {
    return ACTION_CATEGORY_GENERAL;
  }
  const explicit = ACTION_CATEGORY_BY_KEY[actionKey];
  if (explicit) return explicit;

  if (actionKey.includes(".")) {
    const [prefix] = actionKey.split(".");
    if (TOP_LEVEL_SIDEBAR_LABELS[prefix]) return prefix;
    if (ACTION_CATEGORY_PREFIX_ALIASES[prefix]) {
      return ACTION_CATEGORY_PREFIX_ALIASES[prefix];
    }
  }
  return ACTION_CATEGORY_GENERAL;
}

/**
 * Bucket `available_actions` into ordered, non-empty sidebar categories.
 * `generalLabel` is passed in so the caller supplies it from `AppStrings` at
 * render time — reading it here at module load would freeze the TCM value.
 *
 * @template {{ key: string, display_name?: string }} T
 * @param {T[]} actions
 * @param {string} generalLabel
 * @returns {Array<{ id: string, label: string, actions: T[] }>}
 */
export function groupActionsByCategory(actions, generalLabel = "General") {
  const byCategory = new Map();
  (actions ?? []).forEach((action) => {
    if (!action?.key) return;
    const id = resolveActionCategoryId(action.key);
    if (!byCategory.has(id)) byCategory.set(id, []);
    byCategory.get(id).push(action);
  });

  return ACTION_CATEGORY_ORDER.filter((id) => byCategory.has(id)).map((id) => ({
    id,
    label:
      id === ACTION_CATEGORY_GENERAL
        ? generalLabel
        : (TOP_LEVEL_SIDEBAR_LABELS[id] ?? id),
    actions: byCategory.get(id),
  }));
}
